// extracted by mini-css-extract-plugin
module.exports = {"cards-grid":"agent-delivers-section_cards-grid__fBL_6"};